import styled from 'styled-components';

const Bullet = styled.div`
  width: 0.5rem;
  height: 0.5rem;
  aspect-ratio: 1/1;
  border-radius: 50%;
  background-color: var(--primary-700);
  display: flex;
  align-self: center;
  justify-self: center;
`;

export default Bullet;
